import { render, staticRenderFns } from "./chocieOldPeople.vue?vue&type=template&id=34d77ab7&scoped=true&"
import script from "./chocieOldPeople.vue?vue&type=script&lang=js&"
export * from "./chocieOldPeople.vue?vue&type=script&lang=js&"
import style0 from "./chocieOldPeople.vue?vue&type=style&index=0&id=34d77ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d77ab7",
  null
  
)

export default component.exports